import { createPricingTimeRequest } from "../../data/pricingTimeApi";
import { validatePricingTimePayload } from "../validator/validatePricingTimePayload";

export async function createPricingTimeUseCase(payload) {
  const error = validatePricingTimePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createPricingTimeRequest(payload);
}
